export default __webpack_public_path__ + "static/media/LO03.58ff21ed.mp3";